export default "/images/clipboard.png?624e85110f70e742c9f964e7f61fbf44";